import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
import CreateAxios from '../axiosComponent/create';


const MyVendorComponent = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [cities, setcontent] = useState([])
    const [isloading, setisloading] = useState(false)
    useEffect(() => {
        // let locations = ReadAxios({ url: 'consigneeMaster' }) || [];
        // locations.then((res) => {
        //     // console.log('>>>>>', res.data.resultSet)
        //     setcities(res.data.resultSet)
        //     setisloading(false)
        // })
    }, [])

    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setisloading(true)
            let searchTerm = data.searchQuery
            CreateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster`, payload: { searchTerm: searchTerm } })
                .then((result) => {
                    console.log("Result : ", result.data.resultSet)
                    let tempown = [];
                    let vendorData = result.data.resultSet;
                    for (let index = 0; index < vendorData.length; index++) {
                        if (vendorData[index].vendorOwnershipType == 0 || vendorData[index].vendorOwnershipType == null) {
                            tempown.push(vendorData[index]);
                        }
                    }
                    console.log(tempown);
                    setcontent(tempown)
                    setisloading(false)
                })
        }
    }

    let cityNames = []
    if (cities.length > 0) {
        cities.map((object, index) => {
            let temp = {}
            temp.raw = { ...object }
            temp.key = object.transporterMasterId
            temp.text = `${object.transporterName} (${object.transporterCode})`
            temp.value = object.transporterMasterId
            return cityNames[index] = temp
        })
    }

    let handleChange = (value, data) => {
        console.log('text', data);
        let op = data.options
        op.map((item, o) => {
            console.log(item.raw.transporterMasterId);
            if (item.raw.transporterMasterId == data.value) {
                setFieldValue("vendor_name", item.raw.transporterName)
            }
        })
        if (data.value == "") {
            console.log('in if v');
            setFieldValue("vendor_name", "")
        }
        setFieldValue(name, data.value);

    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={isloading ? true : false}
            style={{ width: "100%" }}
            onChange={handleChange}
            // search
            // onChange={handleChange}
            options={cityNames}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyVendorComponent